/**
 * Kamus layar **sesi kas, settlement, dan login PIN**.
 *
 * ⚠️ Teks di sini bukan hiasan — beberapa di antaranya **bagian dari kontrol**:
 * - `masuk.gagal` sengaja SERAGAM untuk "kode staf tak ada" dan "PIN salah". Membedakannya
 *   memberi tahu penyerang kode staf mana yang nyata.
 * - `tutup.hitungButa` menjelaskan KENAPA angka "seharusnya" belum ditampilkan. Tanpa penjelasan,
 *   kasir akan mengira layarnya rusak lalu mencari cara melihat angkanya lebih dulu.
 */
export const sessionId = {
  cancel: 'Kembali',
  report: {
    store: 'Cetak Z-Report Toko',
    x: 'Cetak X-Report',
    z: 'Cetak Z-Report',
    sent: 'Terkirim ke printer.',
    /* ⚠️ Bukan galat — rekapnya ada, cuma perangkat ini bukan terminal ber-printer. */
    noDevice: 'Rekap dibuat, tapi perangkat ini tak punya jalur cetak.',
    sales: 'Penjualan',
    expected: 'Kas seharusnya',
  },
  title: 'Sesi Kas',
  logout: 'Keluar',
  pair: {
    title: 'Pasangkan Perangkat',
    /* ⚠️ Menyebut DI MANA kodenya dibuat — pesan yang tak bisa ditindaklanjuti sama saja diam. */
    hint: 'Minta kode di portal: Lantai → perangkat → Pasangkan',
    code: 'Kode pemasangan',
    button: 'Pasangkan',
    failed: 'Kode tak berlaku — mungkin salah ketik, sudah lewat 15 menit, atau sudah dipakai. Minta kode baru di portal.',
  },
  loggedIn: {
    title: 'Masuk Kasir',
    staffCode: 'Kode staf',
    button: 'Masuk',
    /** ⛔ SERAGAM — jangan pernah dipecah jadi "staf tak ditemukan" vs "PIN salah". */
    failed: 'Kode staf atau PIN salah',
    /** ⚠️ Bukan "PIN salah": yang kurang satu kali login daring, bukan digitnya. */
    offlineUnknown: 'Server tak terjangkau, dan staf ini belum pernah masuk di perangkat ini. Butuh sekali login saat daring.',
    offlineExpired: 'Server tak terjangkau, dan izin tersimpan sudah lewat 7 hari. Butuh sekali login saat daring.',
    locked: 'Terlalu banyak percobaan. Coba lagi 5 menit lagi.',
  },
  open: {
    title: 'Buka Sesi Kas',
    /* ⭐ Identitas sesi — dibaca sebelum angka apa pun diketik. */
    businessDate: 'Hari usaha',
    cashier: 'Kasir',
    terminal: 'Terminal',
    floatTitle: 'Verifikasi modal awal',
    /* ⛔ Menyuruh MENGHITUNG, bukan mengetik: yang dihitung fisik, bukan yang diingat. */
    floatHint: 'Hitung dulu uang kembalian di laci, baru ketik jumlahnya.',
    openingFloat: 'Modal awal laci',
    note: 'Catatan (opsional)',
    notePlaceholder: 'mis. modal kurang Rp20.000, diambil dari brankas',
    button: 'Buka Sesi',
    /* ⛔ Sesi kas BARU tak bisa dibuka luring — gerbang K20 hidup di server (lihat SessionShell). */
    offlineBlocked: 'Sesi kas baru tak bisa dibuka saat server tak terjangkau. Sambungkan dulu — sesi yang sudah terbuka tetap bisa dipakai.',
  },
  /**
   * ⭐ Layar SESUDAH sesi tertutup — lembar, tawaran tutup toko, lalu pulang.
   * ⚠️ Teksnya menyebut bahwa sesinya SUDAH tertutup: kasir yang mengira belum akan menekan ulang.
   */
  closed: {
    title: 'Sesi Ditutup',
    note: 'Sesi kas sudah tertutup. Cetak ulang laporan bila kertasnya macet.',
    checking: 'Memeriksa sesi lain di outlet ini…',
    othersOpen: 'Masih ada {{n}} sesi kas terbuka di outlet ini — tutup toko menunggu semuanya selesai.',
    /* ⭐ Menyebut TILL-nya: "berapa" tak bisa ditindaklanjuti, "yang mana" bisa. */
    othersOpenNamed: 'Tutup toko menunggu {{n}} sesi kas yang masih terbuka: {{tills}}.',
    finish: 'Selesai & Keluar',
  },
  close: {
    title: 'Tutup Sesi Kas',
    /* ⛔ Menyebut ANGKANYA: "ada yang tertahan" tak bisa dinilai, "3 penjualan" bisa. */
    pending: '{{n}} penjualan belum diakui portal. Sesi tak bisa ditutup dulu — hitungan lacinya pasti meleset.',
    countInput: 'Hitungan uang di laci',
    blindCount: 'Hitung uang di laci dulu, lalu ketik jumlahnya. Angka seharusnya baru muncul setelah itu.',
    retained: 'Ditahan untuk modal shift berikutnya (opsional)',
    deposit: 'Disetor: {{amount}}',
    witness: 'Disaksikan penyelia (opsional)',
    witnessCode: 'Kode staf penyelia',
    witnessPin: 'PIN penyelia',
    expected: 'Seharusnya',
    counted: 'Dihitung',
    variance: 'Selisih',
    reasonRequired: 'Selisih tidak nol — pilih alasannya',
    submitReason: 'Kirim & tutup sesi',
    button: 'Hitung & Tutup',
    done: 'Selesai',
  },
  settlement: {
    title: 'Tutup Toko (Settlement)',
    warning: 'Setelah tutup toko, transaksi hari ini TIDAK bisa di-void, dibuka kembali, atau ditambah.',
    pending: '{{n}} penjualan belum diakui portal. Tutup toko menunggu sampai semuanya terkirim — kalau tidak, penjualan itu tiba di hari yang sudah ditutup dan ditolak selamanya.',
    button: 'Tutup Toko',
    ok: 'Toko ditutup — {{shift}} sesi kas tercatat',
  },
};

export const sessionEn: typeof sessionId = {
  cancel: 'Back',
  report: {
    store: 'Print Store Z-Report',
    x: 'Print X-Report',
    z: 'Print Z-Report',
    sent: 'Sent to printer.',
    noDevice: 'Report ready, but this device has no print path.',
    sales: 'Sales',
    expected: 'Expected cash',
  },
  title: 'Cash Session',
  logout: 'Sign out',
  pair: {
    title: 'Pair Device',
    hint: 'Get a code in the portal: Floor → device → Pair',
    code: 'Pairing code',
    button: 'Pair',
    failed: 'Code not valid — mistyped, older than 15 minutes, or already used. Get a new code in the portal.',
  },
  loggedIn: {
    title: 'Cashier Sign-in',
    staffCode: 'Staff code',
    button: 'Sign in',
    failed: 'Wrong staff code or PIN',
    offlineUnknown: 'Server unreachable, and this staff has never signed in on this device. One online sign-in is needed.',
    offlineExpired: 'Server unreachable, and the stored permissions are older than 7 days. One online sign-in is needed.',
    locked: 'Too many attempts. Try again in 5 minutes.',
  },
  open: {
    title: 'Open Cash Session',
    businessDate: 'Business date',
    cashier: 'Cashier',
    terminal: 'Terminal',
    floatTitle: 'Verify opening float',
    floatHint: 'Count the change in the drawer first, then type the amount.',
    openingFloat: 'Opening float',
    note: 'Note (optional)',
    notePlaceholder: 'e.g. short by Rp20,000, topped up from the safe',
    button: 'Open Session',
    offlineBlocked: 'A new cash session cannot be opened while the server is unreachable. Reconnect first — an already-open session still works.',
  },
  closed: {
    title: 'Session Closed',
    note: 'The cash session is closed. Reprint the report if the paper jammed.',
    checking: 'Checking other sessions at this outlet…',
    othersOpen: '{{n}} cash session(s) still open at this outlet — closing the store waits for all of them.',
    othersOpenNamed: 'Closing the store is waiting on {{n}} open cash session(s): {{tills}}.',
    finish: 'Finish & Sign out',
  },
  close: {
    title: 'Close Cash Session',
    pending: '{{n}} sale(s) not yet acknowledged by the portal. The session cannot close yet — the drawer count would be wrong.',
    countInput: 'Cash counted in drawer',
    blindCount: 'Count the drawer first, then type the amount. The expected figure appears only after that.',
    retained: 'Retained as next shift float (optional)',
    deposit: 'Deposited: {{amount}}',
    witness: 'Witnessed by supervisor (optional)',
    witnessCode: 'Supervisor staff code',
    witnessPin: 'Supervisor PIN',
    expected: 'Expected',
    counted: 'Counted',
    variance: 'Variance',
    reasonRequired: 'Variance is not zero — choose a reason',
    submitReason: 'Submit & close session',
    button: 'Count & Close',
    done: 'Done',
  },
  settlement: {
    title: 'Close Store (Settlement)',
    warning: 'After closing the store, today’s transactions CANNOT be voided, reopened, or added to.',
    pending: '{{n}} sales are not yet acknowledged by the portal. Closing waits until they are all sent — otherwise they arrive into a closed day and are rejected forever.',
    button: 'Close Store',
    ok: 'Store closed — {{shift}} cash sessions recorded',
  },
};
